var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'loader-overlay',
    _vm.themeClass,
    { 'is-active': _vm.isActive }
]},[_c('Loader',{attrs:{"is-active":_vm.isActive}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }